
const contractDlg = {
    state: {
      contractDlgState: false,
      contractDlgSelData:[],
      clickContractData:"",
    },
  
    mutations: {
      SET_CONTRACTDLGSTATE: (state, contractDlgState) => {
        state.contractDlgState = contractDlgState
      },
      SET_CONTRACTDLGSELDATA: (state, contractDlgSelData) => {
        state.contractDlgSelData = contractDlgSelData
      },
      SET_CLICKCONTRACTDATA: (state, clickContractData) => {
        state.clickContractData = clickContractData
      },
    },
  
    actions: {
      
    }
  }
  
  export default contractDlg
  